export default {
      id: "pikto-web-usage",
      viewBox: "0 0 3.19 3.19",
      url: __webpack_public_path__ + "../images/sprites.svg#pikto-web",
      toString: function () {
        return this.url;
      }
    }